import { RootState } from "../store";

export const whoisModalVisibleSelector = (state: RootState) =>
  state.ui.whoisModalVisible;

export const languageSelector = (state: RootState) => state.ui.language;
